const initialState = {
    recipientsPending: false,
    sendPending: false,
    recipients: [],
    result: null,
    recipientsError: null,
    sendError: null
};

const directNotificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_DIRECT_NOTIFICATION_RECIPIENTS_PENDING':
            return {
                ...state,
                recipientsPending: true,
                recipientsError: null
            };
        case 'GET_DIRECT_NOTIFICATION_RECIPIENTS_SUCCESS':
            return {
                ...state,
                recipientsPending: false,
                recipients: action.recipients,
                recipientsError: null
            };
        case 'GET_DIRECT_NOTIFICATION_RECIPIENTS_ERROR':
            return {
                ...state,
                recipientsPending: false,
                recipientsError: action.error
            };
        case 'SEND_DIRECT_NOTIFICATION_PENDING':
            return {
                ...state,
                sendPending: true,
                result: null,
                sendError: null
            };
        case 'SEND_DIRECT_NOTIFICATION_SUCCESS':
            return {
                ...state,
                sendPending: false,
                result: action.result,
                sendError: null
            };
        case 'SEND_DIRECT_NOTIFICATION_ERROR':
            return {
                ...state,
                sendPending: false,
                sendError: action.error
            };
        case 'CLEAR_DIRECT_NOTIFICATION_STATUS':
            return {
                ...state,
                result: null,
                sendError: null
            };
        default:
            return state;
    }
};

export default directNotificationsReducer;
